
import Tradertype from '@/components/service/newjoin/Tradertype.vue'
export default {
  components: { Tradertype },
  props: {},
  data() {
    return {
      tabdata: [
        {
          index: 0,
          title: this.$v('持牌机构邮箱验证'),
          p: this.$v('有效牌照公布的邮箱，收取验证码'),
          color: '#6574E6',
          bg: '#E9E9FB',
          icon: 'icon-qiyeyouxiangyanzhengjiaru1'
        },
        {
          index: 1,
          title: this.$v('企业邮箱验证'),
          p: this.$v('使用非员工邮箱，收取验证码'),
          color: '#BA8434',
          bg: '#F7EDD9',
          icon: 'icon-qiyeyouxiangyanzhengjiaru'
        }
      ]
    }
  },
  computed: {}
}
